import React from "react";

export default {
// 没有冰雹的图片，暂时使用雨，
    'xue': require("../../assets/images/weather/xue.png"),
    'lei': require("../../assets/images/weather/lei.png"),
    'shachen': require("../../assets/images/weather/shachen.png"),
    'wu': require("../../assets/images/weather/wu.png"),
    'bingbao': require("../../assets/images/weather/yu.png"),
    'yun': require("../../assets/images/weather/yun.png"),
    'yu': require("../../assets/images/weather/yu.png"),
    'yin': require("../../assets/images/weather/yin.png"),
    'qing': require("../../assets/images/weather/qing.png"),


    '霾': require("../../assets/images/weather/d-mai.png"),
    '暴雪': require("../../assets/images/weather/d-baoxue.png"),
    '大雪转暴雪': require("../../assets/images/weather/d-daxuezhuanbaoxue.png"),
    '大雪': require("../../assets/images/weather/d-daxue.png"),
    '晴': require("../../assets/images/weather/d-qing.png"),
    '阵雪': require("../../assets/images/weather/d-zhenxue.png"),
    '中雪': require("../../assets/images/weather/d-zhongxue.png"),
    '特大暴雨': require("../../assets/images/weather/d-tedabaoyu.png"),
    '大暴雨转特大暴雨': require("../../assets/images/weather/d-dabaoyuzhuantedabaoyu.png"),
    '大暴雨': require("../../assets/images/weather/d-dabaoyu.png"),
    '阴': require("../../assets/images/weather/d-yin.png"),
    '中雨': require("../../assets/images/weather/d-zhongyu.png"),
    '雨夹雪': require("../../assets/images/weather/d-yujiaxue.png"),
    '小雨': require("../../assets/images/weather/d-xiaoyu.png"),
    '多云': require("../../assets/images/weather/d-duoyun.png"),
    '雷阵雨伴有冰雹': require("../../assets/images/weather/d-leizhenyubanyoubingbao.png"),
    '大雨': require("../../assets/images/weather/d-dayu.png"),
    '浮尘': require("../../assets/images/weather/d-fuchen.png"),
    '小雪转中雪': require("../../assets/images/weather/d-xiaoxuezhuanzhongxue.png"),
    '沙尘暴': require("../../assets/images/weather/d-shachenbao.png"),
    '暴雨': require("../../assets/images/weather/d-baoyu.png"),
    '雷阵雨': require("../../assets/images/weather/d-leizhenyu.png"),
    '扬沙': require("../../assets/images/weather/d-yangsha.png"),
    '小雪': require("../../assets/images/weather/d-xiaoxue.png"),
    '冻雨': require("../../assets/images/weather/d-dongyu.png"),
    '大雨转暴雨': require("../../assets/images/weather/d-dayuzhuanbaoyu.png"),
    '强沙尘暴': require("../../assets/images/weather/d-qiangshachenbao.png"),
    '阵雨': require("../../assets/images/weather/d-zhenyu.png"),
    '中雨转大雨': require("../../assets/images/weather/d-zhongyuzhuandayu.png"),
    '小雨转中雨': require("../../assets/images/weather/d-xiaoyuzhuanzhongyu.png"),
    '暴雨转大暴雨': require("../../assets/images/weather/d-baoyuzhuandabaoyu.png"),
    '雾': require("../../assets/images/weather/d-wu.png"),
    '小雨转阴': require("../../assets/images/weather/d-xiaoyu.png"),
    '阴转多云': require("../../assets/images/weather/d-duoyun.png"),
}